import React, { Fragment, useState } from 'react';
import Table from '../../../../../components/_table/Table';
import CheckBox from '../../../../../components/input/CheckBox';
import ListBox from '../../../../../components/outline/ListBox';
import Button from '../../../../../components/Button';
import Select from '../../../../../components/input/Select';
import Input from '../../../../../components/input/Input';
import { MAXIMUM_NUMBER_OF_INVOICE_NUMBER } from '../../../../../constants/service/common/utilConstants';
import {
  ORDER_ITEM_DELIVERY_TYPE_SEARCH_SELECT_LIST,
  ORDER_DELIVERY_TYPE,
} from '../../../../../constants/service/app/orderConstants';
import { ORDER_MANAGEMENT_LIST_FILTER_OPTION_MODEL } from '../../../../../store/modules/order/models';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { numberKeyPress } from '../../../../../lib/common';
import { REX_EXCEPT_NUMBER } from '../../../../../lib/rex';
import columns from './columns';
import './OrderManagementList.scss';

const OrderManagementList = (props) => {
  const {
    orderManagementList,
    setData,
    getList,
    deliveryPreparation,
    deliveryDelay,
    checkDeliveryDispatch,
    onChangeDeliveryInfo,
    applyBulkDeliveryInfo,
    onCheckOrderItem,
    excelBulkDeliveryDispatch,
    cancelSales,
    editBuyerInfo,
    editDeliveryInfo,
    getAllManagementListExcelDownLoad,
    getSelectedManagementListExcelDownLoad,
  } = props;
  const { list, filterOption, pagination, deliveryAgentList, registerDeliveryInfo, selectedOrderItemList } =
    orderManagementList;

  const [shouldSplitDownload, setShouldSplitDownload] = useState(false);

  return (
    <ListBox
      className="order-management-list"
      head={
        <div className="excel-btn-area">
          <CheckBox text={'브랜드별 파일 구분'} checked={shouldSplitDownload} onChange={setShouldSplitDownload} />
          <Button
            isRadius={true}
            text="선택 주문 엑셀 다운로드"
            onClick={() =>
              getSelectedManagementListExcelDownLoad({
                split: shouldSplitDownload,
              })
            }
          />
          <Button
            isRadius={true}
            text="검색 결과 전체 주문 엑셀 다운로드"
            onClick={() =>
              getAllManagementListExcelDownLoad({
                split: shouldSplitDownload,
              })
            }
          />
        </div>
      }
      body={
        <Fragment>
          <div className="order-management-list-body-area">
            <div className="left-btn-area">
              <div className="button-form">
                <div className="label">주문확인</div>
                <div className="button-list">
                  <Button text="상품 준비" onClick={() => deliveryPreparation()} />
                  <Button text="배송 지연처리" onClick={() => deliveryDelay()} />
                </div>
              </div>

              <div className="button-form">
                <div className="label">발송 처리</div>
                <div className="button-list">
                  <Button text="발송 처리" onClick={() => checkDeliveryDispatch()} />
                  <Button text="엑셀 일괄 배송" onClick={() => excelBulkDeliveryDispatch()} />
                </div>
              </div>
            </div>

            <div className="right-btn-area">
              <div className="button-form">
                <div className="label">취소처리</div>
                <div className="button-list">
                  <Button text="판매 취소" onClick={() => cancelSales()} />
                </div>
              </div>

              <div className="button-form">
                <div className="label">정보 수정</div>
                <div className="button-list">
                  <Button text="주문자 정보 수정" onClick={() => editBuyerInfo()} />
                  <Button text="송장 수정" onClick={() => editDeliveryInfo()} />
                </div>
              </div>
            </div>

            <div className="full-btn-area">
              <div className="button-form">
                <div className="label">송장정보</div>
                <div className="button-list">
                  <Select
                    list={ORDER_ITEM_DELIVERY_TYPE_SEARCH_SELECT_LIST}
                    onChange={(id) => onChangeDeliveryInfo({ deliveryType: id })}
                    value={registerDeliveryInfo.deliveryType}
                    size="default"
                    isTable={true}
                  />

                  <Select
                    list={deliveryAgentList}
                    onChange={(id) => onChangeDeliveryInfo({ deliveryAgentId: id })}
                    disabled={registerDeliveryInfo.deliveryType !== ORDER_DELIVERY_TYPE.PARCEL_DELIVERY}
                    value={registerDeliveryInfo.deliveryAgentId}
                    size="default"
                    isTable={true}
                  />

                  <Input
                    value={registerDeliveryInfo.invoiceNumber}
                    onKeyUp={(e) => numberKeyPress(e)}
                    onChange={(value) => onChangeDeliveryInfo({ invoiceNumber: value.replace(REX_EXCEPT_NUMBER, '') })}
                    placeholder="송장번호를 입력하세요."
                    disabled={registerDeliveryInfo.deliveryType !== ORDER_DELIVERY_TYPE.PARCEL_DELIVERY}
                    maxLength={MAXIMUM_NUMBER_OF_INVOICE_NUMBER}
                  />

                  <Button text="선택건 적용" color="primary" onClick={() => applyBulkDeliveryInfo()} />
                </div>
              </div>
            </div>
          </div>

          <Table
            className="order-management-list-table"
            rowKey={(record) => record.orderItemId}
            list={list}
            onCheck={(data) => onCheckOrderItem(data)}
            selectedList={selectedOrderItemList}
            initialOption={{
              filterOption: ORDER_MANAGEMENT_LIST_FILTER_OPTION_MODEL,
              pagination: _LIST_PAGINATION_MODEL,
            }}
            filterOption={filterOption}
            pagination={pagination}
            getList={getList}
            scroll={{ x: true }}
            columns={(utils) =>
              columns({
                deliveryAgentList,
                setData,
                ...utils,
              })
            }
          />
        </Fragment>
      }
    />
  );
};

export default OrderManagementList;
